import { put, takeLatest, call, all } from 'redux-saga/effects';
import api from '../../../services/api';
import notification from '../../../services/notification';
import types from '../../types';

function* getRobot({ payload }) {
  try {
    const { status, data } = yield call(api.market.robot.getRobot, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_MARKET_MAKER_SUCCESS, payload: data });
    yield put({ type: types.GET_MARKET_VOLUME_RATES_START });
  } catch (error) {
    yield put({ type: types.GET_MARKET_MAKER_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* putRobot({ payload }) {
  try {
    const { data, status } = yield call(api.market.robot.putRobot, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_MARKET_MAKER_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.PUT_MARKET_MAKER_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* putToggleEnabled() {
  try {
    const { data, status } = yield call(api.market.robot.putToggleEnabled);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_TOGGLE_ENABLED_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.PUT_TOGGLE_ENABLED_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* putToggleVersionBotsEnabled({ payload }) {
  try {
    const { data, status } = yield call(
      api.market.robot.putToggleEnabledVersionBots,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({
      type: types.PUT_TOGGLE_VERSION_BOTS_ENABLED_SUCCESS,
      payload: { ...data, bot_version: payload.bot_version },
    });
  } catch (error) {
    yield put({ type: types.PUT_TOGGLE_VERSION_BOTS_ENABLED_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getMarketVolumeRates() {
  try {
    const { status, data } = yield call(api.market.robot.getMarketVolumeRates);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_MARKET_VOLUME_RATES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_MARKET_VOLUME_RATES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* updateMarketVolumeRate({ payload }) {
  try {
    const { data, status } = yield call(
      api.market.robot.updateMarketVolumeRate,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_MARKET_VOLUME_RATE_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.UPDATE_MARKET_VOLUME_RATE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* updateMarketVolumeLimits({ payload }) {
  try {
    const { data, status } = yield call(
      api.market.robot.updateMarketVolumeLimits,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_MARKET_VOLUME_LIMITS_SUCCESS });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.UPDATE_MARKET_VOLUME_LIMITS_FAILURE });
    if (error?.response?.status === 401) return;

    if (
      error?.response?.data?.errors?.volume_min?.includes(
        'min_volume_must_be_less_than_max_volume',
      ) ||
      error?.response?.data?.errors?.volume_max?.includes(
        'max_volume_must_be_greater_than_min_volume',
      )
    ) {
      notification({
        type: 'error',
        message:
          'Min volume must be less than max volume and max volume must be greater than min volume!',
      });
      return;
    }
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* robot() {
  yield all([
    takeLatest(types.GET_MARKET_MAKER_START, getRobot),
    takeLatest(types.PUT_MARKET_MAKER_START, putRobot),
    takeLatest(types.PUT_TOGGLE_ENABLED_START, putToggleEnabled),
    takeLatest(
      types.PUT_TOGGLE_VERSION_BOTS_ENABLED_START,
      putToggleVersionBotsEnabled,
    ),
    takeLatest(types.GET_MARKET_VOLUME_RATES_START, getMarketVolumeRates),
    takeLatest(types.UPDATE_MARKET_VOLUME_RATE_START, updateMarketVolumeRate),
    takeLatest(types.UPDATE_MARKET_VOLUME_LIMITS_START, updateMarketVolumeLimits),
  ]);
}
